import axios from "@/api/customerSystem";
let method = 'GET';
/*培育系统APP经营行业*/
export const add=data=>axios.post('/smesKeyServiceNeedsRest/add',data)
